import { useParams } from 'react-router';

import { useGetMatchByIdQuery } from 'api/fspApi';
import config from 'utils/config';

type MatchParams = {
  competitionName: string;
  seasonYear: string;
  matchId: string;
};

export const useMatchData = () => {
  const { competitionName, seasonYear: urlSeasonYear, matchId } = useParams<MatchParams>();
  const competition = config.competitions.find((item) => item.name === competitionName) || config.competitionsDefault;
  const seasonYear = urlSeasonYear ?? `${new Date().getFullYear()}`;

  const { data: match, error: matchIsError, isLoading: matchLoading } = useGetMatchByIdQuery(matchId!);

  return {
    competition,
    competitionId: competition?.id,
    matchData: match!,
    matchId: matchId!,
    seasonYear,
    matchIsError,
    matchLoading,
  };
};
